// extracted by mini-css-extract-plugin
module.exports = {"title":"title--R0+Av"};